<ideal-standard-cart-item-summary-view [itemId]="id()" [quantity]="cartItemQuantity()" />
